import React from 'react';
import {InPageAlert} from '@snsw-gel/react';
import TollAccountType from '../../types/tollAccountType';
import TollReliefConfig from '../../config/TollReliefConfig';

interface SuccessfulLinkAlertProps {
    /** The type of the toll account that was just successfully linked */
    readonly tollAccountType: TollAccountType;
}

const SuccessfulLinkAlert: React.FC<SuccessfulLinkAlertProps> = ({tollAccountType}) => {
    let title: string;
    let alertId: string;
    switch (tollAccountType) {
        case TollAccountType.Personal:
            title = 'Personal toll account updated';
            alertId = 'personal-toll-alert';
            break;
        case TollAccountType.Business:
            title = 'Business toll account updated';
            alertId = 'business-toll-alert';
            break;
        case TollAccountType.Mixed:
            title = 'Mixed toll account updated';
            alertId = 'mixed-toll-alert';
            break;
    }

    return <InPageAlert variant='success' title={title} id={alertId}>
        Toll details have been saved and your toll spend will be updated in Toll Tracker.
        <br/> <br/>
        If you have finished managing your toll accounts you can{' '}
        <a
            href={TollReliefConfig.urls.tollTrackerURL}
            target='_self'
            rel='noreferrer'
        >
            view the Toll Tracker
        </a>
        .
    </InPageAlert>;
};

export default SuccessfulLinkAlert;
